/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-15 14:57:17
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-08 10:31:48
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/ContentGroup/ModulesGenerator/ResponsiveText.ts
 */
import { ActionType } from 'src/types/common/common';

import {
  //ProductList,
  //   LongCanvas,
  //   Text,
  //   Text,
  //   ProductGridDisplay,
  ResponsiveText,
  //   ListAdaptor,
} from 'src/constrains/DraggableModules/Components';

const ResponsiveTextFunctions = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
}) => {
  const handleOnTextStaticChange = (id, data) => {
    if (onStaticChange) {
      onStaticChange({
        type: ActionType.modify,
        id,
        data,
      });
    }
  };
  return {
    handleOnTextStaticChange,
    //  handleOnTextModuleTypeChange,
  };
};
const generateResponsiveText = ({
  onDynamicChange,
  onStaticChange,
  onModuleTypeChange,
}) => {
  const { handleOnTextStaticChange } = ResponsiveTextFunctions({
    onDynamicChange,
    onStaticChange,
    onModuleTypeChange,
  });
  return {
    component: ResponsiveText,
    props: {
      onStaticChange: handleOnTextStaticChange,
    },
  };
};
export { generateResponsiveText };
